<div class="date-picker-input">
  <label class="form-label" *ngIf="label">
    {{ label }}
    <span class="text-danger" *ngIf="required">*</span>
  </label>

  <div *ngIf="mode === 'single'" class="single-date-group">
    <div class="input-group">
      <input
        [ngClass]="inputClass"
        [class.is-invalid]="!!displayError"
        [type]="inputType"
        [placeholder]="placeholder"
        [value]="singleValue"
        [attr.min]="minInputValue"
        [attr.max]="maxInputValue"
        [readonly]="readonly"
        [disabled]="disabled"
        (input)="onSingleChange($any($event.target).value)"
        (blur)="markTouched()"
      />
      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="disabled || readonly"
        (click)="setToday()"
      >
        Today
      </button>
    </div>
  </div>

  <div *ngIf="mode === 'range'" class="range-date-group">
    <div class="row g-2">
      <div class="col-12 col-md-6">
        <label class="form-label">Start</label>
        <input
          [ngClass]="inputClass"
          [class.is-invalid]="!!displayError"
          [type]="inputType"
          [placeholder]="placeholder"
          [value]="rangeStart"
          [attr.min]="minInputValue"
          [attr.max]="maxInputValue"
          [readonly]="readonly"
          [disabled]="disabled"
          (input)="onRangeStartChange($any($event.target).value)"
          (blur)="markTouched()"
        />
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label">End</label>
        <input
          [ngClass]="inputClass"
          [class.is-invalid]="!!displayError"
          [type]="inputType"
          [placeholder]="placeholder"
          [value]="rangeEnd"
          [attr.min]="minInputValue"
          [attr.max]="maxInputValue"
          [readonly]="readonly"
          [disabled]="disabled"
          (input)="onRangeEndChange($any($event.target).value)"
          (blur)="markTouched()"
        />
      </div>
    </div>

    <button
      type="button"
      class="btn btn-secondary mt-2"
      [disabled]="disabled || readonly"
      (click)="setToday()"
    >
      Set Today for Both
    </button>
  </div>

  <div class="form-text" *ngIf="helperText">{{ helperText }}</div>
  <div class="form-text" *ngIf="timezoneAware && includeTime">
    Timezone-aware mode: local input is converted to UTC using {{ resolvedTimezone }}.
  </div>
  <small class="invalid-feedback d-block" *ngIf="displayError">{{ displayError }}</small>
</div>
